var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OpenloginAdapter as OpenloginAdapterOriginal } from "@web3auth/openlogin-adapter";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { ADAPTER_EVENTS, ADAPTER_STATUS, BaseAdapter, SUPPORTED_ADAPTERS, log, } from "../base";
import Web3 from "web3";
export class OpenloginAdapter extends BaseAdapter {
    constructor(params = { chainId: "0x1" }) {
        super(params);
        this.name = SUPPORTED_ADAPTERS.OPENLOGIN;
        this.status = ADAPTER_STATUS.NOT_READY;
        this.openloginAdapterOriginal = null;
        this.adapterOptions = Object.assign({}, params);
    }
    get provider() {
        if (this.status === ADAPTER_STATUS.CONNECTED &&
            this.openloginAdapterOriginal) {
            return this.openloginAdapterOriginal.provider;
        }
        return null;
    }
    get chainId() {
        //   if (this.openloginProvider) {
        //     return this.openloginProvider.chainId;
        //   }
        return null;
    }
    set chainId(_) {
        throw new Error("Not implemented");
    }
    _getChainConfig(chainId) {
        // these are the only chains we support for the usage of web3auth
        if (chainId === 1) {
            return {
                chainNamespace: "eip155",
                chainId: "0x1",
                rpcTarget: `https://rpc.ankr.com/eth`,
                displayName: "Ethereum Mainnet",
                blockExplorer: "https://etherscan.io/",
                ticker: "ETH",
                tickerName: "Ethereum",
                decimals: 18,
            };
        }
        if (chainId === 5) {
            return {
                chainNamespace: "eip155",
                chainId: "0x5",
                rpcTarget: `https://rpc.ankr.com/eth_goerli`,
                displayName: "Goerli Testnet",
                blockExplorer: "https://goerli.etherscan.io/",
                ticker: "ETH",
                tickerName: "Ethereum",
                decimals: 18,
            };
        }
        if (chainId === 137) {
            return {
                chainNamespace: "eip155",
                chainId: "0x89",
                rpcTarget: "https://rpc.ankr.com/polygon",
                displayName: "Polygon Mainnet",
                blockExplorer: "https://polygonscan.com",
                ticker: "MATIC",
                tickerName: "Polygon",
            };
        }
        throw new Error("Chain not supported for web3auth");
    }
    _init(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const privateKeyProvider = new EthereumPrivateKeyProvider({
                    config: {
                        chainConfig: this._getChainConfig(parseInt(this.currentChainConfigId, 16)),
                    },
                });
                this.openloginAdapterOriginal = new OpenloginAdapterOriginal({
                    web3AuthNetwork: this.adapterOptions.adapterSettings.web3AuthNetwork,
                    clientId: this.adapterOptions.adapterSettings.clientId,
                    chainConfig: this._getChainConfig(parseInt(this.currentChainConfigId, 16)),
                    adapterSettings: {
                        uxMode: "popup",
                        loginConfig: {
                            google: this.adapterOptions.adapterSettings.loginConfig.google,
                        },
                    },
                    privateKeyProvider,
                });
                this.openloginAdapterOriginal.on(ADAPTER_EVENTS.READY, (data) => {
                    this.status = ADAPTER_STATUS.READY;
                    this.emit(ADAPTER_EVENTS.READY, data);
                    if (options.autoConnect) {
                        this.connect().catch((err) => {
                            log.error(`Openlogin auto connect failed: ${err}`);
                            this.emit(ADAPTER_EVENTS.ERRORED, err);
                        });
                    }
                });
                this.openloginAdapterOriginal.on(ADAPTER_EVENTS.CONNECTING, (data) => {
                    this.status = ADAPTER_STATUS.CONNECTING;
                    this.emit(ADAPTER_EVENTS.CONNECTING, data);
                });
                this.openloginAdapterOriginal.on("ERRORED", (data) => {
                    this.status = ADAPTER_STATUS.READY;
                    this.emit(ADAPTER_EVENTS.ERRORED, data);
                });
                this.openloginAdapterOriginal.on(ADAPTER_EVENTS.ERRORED, (data) => {
                    this.status = ADAPTER_STATUS.READY;
                    this.emit(ADAPTER_EVENTS.ERRORED, data);
                });
                this.openloginAdapterOriginal.on(ADAPTER_EVENTS.DISCONNECTED, (data) => {
                    this.status = ADAPTER_STATUS.READY;
                    this.emit(ADAPTER_EVENTS.DISCONNECTED, data);
                });
                this.openloginAdapterOriginal.on(ADAPTER_EVENTS.CONNECTED, (data) => __awaiter(this, void 0, void 0, function* () {
                    this.status = ADAPTER_STATUS.CONNECTED;
                    log.debug(`Openlogin before address`);
                    const web3 = new Web3(this.openloginAdapterOriginal.provider);
                    const address = (yield web3.eth.getAccounts())[0].toLowerCase();
                    log.debug(`Openlogin address: ${address}`);
                    this.emit(ADAPTER_EVENTS.CONNECTED, {
                        adapter: SUPPORTED_ADAPTERS.OPENLOGIN,
                        status: { address },
                    });
                }));
                const listener = (data) => {
                    this.openloginAdapterOriginal.off(ADAPTER_EVENTS.READY, listener); // Remove the listener
                    resolve();
                };
                this.openloginAdapterOriginal.on(ADAPTER_EVENTS.READY, listener);
                this.openloginAdapterOriginal.init({});
            });
        });
    }
    _connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.openloginAdapterOriginal)
                throw new Error("Openlogin adapter not initialized");
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const connectedListener = (data) => __awaiter(this, void 0, void 0, function* () {
                    this.off(ADAPTER_EVENTS.CONNECTED, connectedListener); // Remove the listener
                    yield this.postConnected("test");
                    resolve(this.provider);
                });
                this.on(ADAPTER_EVENTS.CONNECTED, connectedListener);
                const erroredListener = (data) => {
                    this.off(ADAPTER_EVENTS.ERRORED, erroredListener); // Remove the listener
                    reject(`Failed to login with openlogin ${data}`);
                };
                this.on(ADAPTER_EVENTS.ERRORED, erroredListener);
                try {
                    yield this.openloginAdapterOriginal.connect({
                        loginProvider: "google",
                    });
                }
                catch (e) {
                    reject(`Failed to login with openlogin ${e}`);
                }
            }));
        });
    }
    _disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.openloginAdapterOriginal.disconnect();
        });
    }
    _switchChain(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.openloginAdapterOriginal.switchChain({ chainId }, false);
            this.setAdapterSettings({
                chainId,
            });
        });
    }
    postConnected(address) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: add post connected logic
        });
    }
}
//# sourceMappingURL=openloginAdapter.js.map